function loadCart(renderHtml = true) {
	$.ajax({
		url: '/cart/load',
		method: 'POST',
		data: { renderHtml: renderHtml, _token: $('meta[name="csrf-token"]').attr('content') },
		success: function (data) {
			if (renderHtml) {
				$('#cartItems').html(data.html);
				$('#cartSubtotal').text(Number(data.sumTotal).toLocaleString('hu-HU') + ' ' + (data.currency || 'Ft'));
			}
			$('.cart-badge').text(data.qty || data.cartItemCount || '0');
		}
	});
}

window.loadCart = loadCart;

$(document).ready(function () {
	if ($('.cart-icon').length) {
		$(document).on('click', '.cart-icon', function (event) {
			event.preventDefault();
			var qty = parseInt($('.cart-badge').first().text() || 0, 10);
			if (qty === 0) {
				GlobalSwal.fire({ title: window.Lang.cart_empty_title, text: window.Lang.cart_empty_text, icon: 'info' });
				return;
			}
			$('#cartDrawer').toggleClass('is-open');
			$('.cart-overlay').toggleClass('is-open');
		});
		$('.cart-close, .cart-overlay').on('click', function () {
			$('#cartDrawer').removeClass('is-open');
			$('.cart-overlay').removeClass('is-open');
		});
		loadCart();
	}

	$('body').on('click', '.saveShareBtn', function () {
		var cartKey = $(this).data('key');
		if (!cartKey) return;
		$('#saveShareCartKey').val(cartKey);
		$('#saveShareEmail').val('');
		$('#saveShareBackdrop').show();
		$('#saveShareModal').css('display', 'flex');
		$('#saveShareEmail').focus();
	});

	function closeSaveShareModal() {
		$('#saveShareModal').hide();
		$('#saveShareBackdrop').hide();
	}

	$('body').on('click', '#saveShareBackdrop, .cart-ss-modal-close, .cart-ss-modal-cancel', closeSaveShareModal);
	$('body').on('submit', '#saveShareForm', function (event) {
		event.preventDefault();
		var cartKey = $('#saveShareCartKey').val();
		var email = $('#saveShareEmail').val().trim();
		if (!cartKey || !email) return;
		var $button = $(this).find('.cart-ss-modal-send').prop('disabled', true);
		$.ajax({
			url: '/cart/save-share',
			method: 'POST',
			data: { key: cartKey, email: email, _token: $('meta[name="csrf-token"]').attr('content') },
			success: function () {
				closeSaveShareModal();
				GlobalSwal.fire({ title: window.Lang.success_title || 'OK', text: window.Lang.save_share_success || '', icon: 'success' });
			},
			error: function () {
				GlobalSwal.fire({ title: window.Lang.error_title_short, text: window.Lang.save_share_error || '', icon: 'error' });
			},
			complete: function () { $button.prop('disabled', false); }
		});
	});

	$('body').on('click', '.cart-summary-thumb-item', function () {
		var $thumb = $(this);
		var src = $thumb.data('src');
		var key = $thumb.data('key');
		if (!src || !key) return;
		$('#cartSummaryMainImg-' + key).attr('src', src).css('visibility', 'visible');
		$thumb.closest('.cart-summary-thumb-list').find('.cart-summary-thumb-item').removeClass('active');
		$thumb.addClass('active');
	});

	$('body').on('click', 'button.removeCartItem', function () {
		var $button = $(this);
		var buttonHtml = $button.html();
		var cartKey = $button.data('key');
		$button.prop('disabled', true);
		GlobalSwal.fire({
			title: window.Lang.cart_remove_confirm_title || window.Lang.cart_delete_title || 'Delete',
			text: window.Lang.cart_remove_confirm_text || '',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: window.Lang.cart_remove_confirm_button || window.Lang.cart_remove || 'Remove',
			cancelButtonText: window.Lang.cart_remove_cancel_button || window.Lang.cart_cancel || 'Cancel'
		}).then(function (result) {
			if (!result.isConfirmed) { $button.prop('disabled', false); return; }
			$button.html(window.animateCircle);
			$.ajax({
				url: '/cart/remove',
				method: 'POST',
				data: { key: cartKey, _token: $('meta[name="csrf-token"]').attr('content') },
				success: function (data) {
					if (data.dataLayerEvent && typeof window.ehgumiPushDataLayerEvent === 'function') {
						window.ehgumiPushDataLayerEvent(data.dataLayerEvent);
					}
					$('#cartItemRow-' + cartKey + ', #cartSummaryRow-' + cartKey).fadeOut(300, function () { $(this).remove(); });
					GlobalSwal.fire({ title: data.title || window.Lang.success_title, text: data.message || window.Lang.cart_remove_success, icon: data.icon || 'success' });
					loadCart();
				},
				error: function () {
					GlobalSwal.fire({ title: window.Lang.error_title_short, text: window.Lang.cart_remove_error, icon: 'error' });
				},
				complete: function () { $('button.removeCartItem[data-key="' + cartKey + '"]').html(buttonHtml).prop('disabled', false); }
			});
		});
	});
});